/* eslint-disable max-len */
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  thunkExecuteAndReturnResultOrShowError,
} from '../../services/base.service';
import { RootState } from '../store';
import {
  getNonPublicStudentById,
  getNonPublicStudentFormViewModel,
  getNonPublicStudentListItems,
  getNonPublicStudentScheduleFormViewModel,
  getScheduleByScheduleId,
  getSchedulesByNpsId,
  getNpsSchoolYears,
} from '../../services/nonPublicStudent.service';
import { NonPublicStudentEntryModel } from '../../types/NonPublicStudentEntryModel';
import { NonPublicStudentFormViewModel } from '../../types/NonPublicStudentFormViewModel';
import { NonPublicStudentListItemModel } from '../../types/NonPublicStudentListItemModel';
import { NonPublicStudentScheduleFormViewModel } from '../../types/NonPublicStudentScheduleFormViewModel';
import { NonPublicStudentScheduleListItemModel } from '../../types/NonPublicStudentScheduleListItemModel';
import { NonPublicStudentScheduleModel } from '../../types/NonPublicStudentScheduleModel';
import { SelectOption } from '../../types/SelectOption';

export const fetchNonPublicStudentListItems = createAsyncThunk(
  'input/fetchNonPublicStudentListItems',
  async (calendarYear: string, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<
      NonPublicStudentListItemModel[]
    >(
      thunkAPI,
      getNonPublicStudentListItems(calendarYear, { signal: thunkAPI.signal })
    );
  }
);

export const fetchNonPublicStudentById = createAsyncThunk(
  'input/fetchNonPublicStudentById',
  async (nonPublicStudentId: string, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<NonPublicStudentEntryModel>(
      thunkAPI,
      getNonPublicStudentById(nonPublicStudentId, { signal: thunkAPI.signal })
    );
  }
);

export const fetchNonPublicStudentFormViewModel = createAsyncThunk(
  'input/fetchNonPublicStudentFormViewModel',
  async (_, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<NonPublicStudentFormViewModel>(
      thunkAPI,
      getNonPublicStudentFormViewModel({ signal: thunkAPI.signal })
    );
  }
);

export const fetchNonPublicStudentScheduleFormViewModel = createAsyncThunk(
  'nonPublicStudent/fetchNonPublicStudentScheduleFormViewModel',
  async (_, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const schoolYear = state.nonPublicStudent.schoolYear;
    const districtId = state.app.selectedDistrict.districtId;
    
    return await thunkExecuteAndReturnResultOrShowError<
      NonPublicStudentScheduleFormViewModel
    >(
      thunkAPI,
      getNonPublicStudentScheduleFormViewModel(districtId, schoolYear, { signal: thunkAPI.signal })
    );
  }
);

export const fetchNonPublicStudentScheduleByNpsId = createAsyncThunk(
  'input/fetchNonPublicStudentScheduleByNpsId',
  async (npsId: string, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<
      NonPublicStudentScheduleListItemModel[]
    >(thunkAPI, getSchedulesByNpsId(npsId, { signal: thunkAPI.signal }));
  }
);

export const fetchNonPublicStudentScheduleByScheduleId = createAsyncThunk(
  'input/fetchNonPublicStudentScheduleByScheduleId',
  async (scheduleId: string, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<NonPublicStudentScheduleModel>(
      thunkAPI,
      getScheduleByScheduleId(scheduleId, {
        signal: thunkAPI.signal,
      })
    );
  }
);

export const fetchNpsSchoolYears = createAsyncThunk(
  'input/fetchNpsSchoolYears',
  async (_, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<SelectOption[]>(
      thunkAPI,
      getNpsSchoolYears({ signal: thunkAPI.signal })
    );
  }
);
